import { Component, OnInit, inject } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { ConfigurablePageComponent } from 'src/app/core/abstracts/configurable-page.component'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { EventService } from 'src/app/core/services/event.service'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { SeoService } from 'src/app/core/services/seo.service'
import { CommonModule } from '@angular/common'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { BrowseByCategoryComponent } from 'src/app/components/browse-by-category/browse-by-category.component'
import { BrowseByMakeComponent } from 'src/app/components/browse-by-make/browse-by-make.component'
import { ContactFormComponent } from 'src/app/components/contact-form/contact-form.component'
import { FeaturedCarouselComponent } from 'src/app/components/featured-carousel/featured-carousel.component'
import { FooterComponent } from 'src/app/components/footer/footer.component'
import { HeaderComponent } from 'src/app/components/header/header.component'
import { HeroBannerComponent } from 'src/app/components/hero-banner/hero-banner.component'
import { SectionComponent } from 'src/app/components/section/section.component'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['../../../assets/page.scss', './home.component.scss'],
  providers: [SeoService],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatSlideToggleModule,
    HeaderComponent,
    FooterComponent,
    SectionComponent,
    ContactFormComponent,
    BrowseByCategoryComponent,
    BrowseByMakeComponent,
    HeroBannerComponent,
    FeaturedCarouselComponent,
  ],
})
export class HomeComponent extends ConfigurablePageComponent implements OnInit {
  private _router = inject(Router)
  private _seoService = inject(SeoService)
  private _eventService = inject(EventService)
  protected globalData = inject(GlobalDataService)

  contactForm = new FormGroup({})

  ngOnInit() {
    const config = this.globalDataService.config()
    this.pageConfig.set(config.page.home)
    this._seoService.init(
      config.seo.data,
      this.pageConfig().seo.data,
    )
  }

  cardClicked(assetId: string) {
    this._router.navigate([RoutePaths.Details, assetId])
  }

  contactClicked(asset: IAsset) {
    this._eventService.notify('contactClicked', asset)
  }
}
